import React from 'react';
import loadable from '@loadable/component';
import {
    IS_BROWSER,
    withRenderStrategy,
} from '../../../../utils/dynamic-rendering';

const LoadableFreeCancellation = loadable(() =>
    import(
        /* webpackChunkName: "free-cancellation" */
        './FreeCancellationContainer'
    )
);

const BaseFreeCancellation = (props) => {
    const element = <LoadableFreeCancellation {...props} />;

    if (IS_BROWSER) {
        return element;
    }

    return null;
};

const DynamicFreeCancellation = withRenderStrategy(BaseFreeCancellation);
DynamicFreeCancellation.displayName = 'FreeCancellation';

export default DynamicFreeCancellation;
